const presOrder = [
  {
    student: "Mukhida, Saniya",
    rand: 0.01120425
  },
  {
    student: "Ming, Theresa",
    rand: 0.040409061
  },
  {
    student: "Mitchell, Beau",
    rand: 0.066677688
  },
  {
    student: "Kamolpornwijit, Woradorn",
    rand: 0.115787612
  },
  {
    student: "Adams, Michael",
    rand: 0.136964291
  },
  {
    student: "Mathis, Benjamin",
    rand: 0.137406185
  },
  {
    student: "Aguilon, Jeremy Arthur",
    rand: 0.156414001
  },
  {
    student: "Avila-Stanley, Yamilex",
    rand: 0.181001434
  },
  {
    student: "Kim, Sang-Chan",
    rand: 0.189510245
  },
  {
    student: "Singh, Yashveer",
    rand: 0.2049239
  },
  {
    student: "Raj, Rishi",
    rand: 0.216449419
  },
  {
    student: "Lawton, Bryanna",
    rand: 0.251877583
  },
  {
    student: "Kim, Seung Lee",
    rand: 0.254811847
  },
  {
    student: "Shoaf, Donald",
    rand: 0.290586139
  },
  {
    student: "Yang, Max",
    rand: 0.293479881
  },
  {
    student: "Gormley, James",
    rand: 0.29732705
  },
  {
    student: "Jiang, Shen",
    rand: 0.313749506
  },
  {
    student: "Lack, Aaron",
    rand: 0.351487213
  },
  {
    student: "Zhang, Raymond",
    rand: 0.40043625
  },
  {
    student: "Nareddy, Tejasvi",
    rand: 0.432847031
  },
  {
    student: "Lee, Johnny",
    rand: 0.476488329
  },
  {
    student: "Mestanza Rossi, Eduardo",
    rand: 0.520889
  },
  {
    student: "Panchamoorthy, Adithyan",
    rand: 0.589556202
  },
  {
    student: "Prada, Gerardo",
    rand: 0.623267083
  },
  {
    student: "Spader, Thomas",
    rand: 0.627245156
  },
  {
    student: "Davis, Brett",
    rand: 0.642482711
  },
  {
    student: "Feng, Christine",
    rand: 0.651411829
  },
  {
    student: "Polstra, Drew",
    rand: 0.687332745
  },
  {
    student: "Light, Thomas",
    rand: 0.692860806
  },
  {
    student: "Nguyen, Johnson",
    rand: 0.750666731
  },
  {
    student: "You, Lynn",
    rand: 0.787938949
  },
  {
    student: "Gallaway, Ryan",
    rand: 0.801776314
  },
  {
    student: "Pirani, Shayan",
    rand: 0.832883906
  },
  {
    student: "Sharma, Swati",
    rand: 0.8395025
  },
  {
    student: "Lun, Kevin",
    rand: 0.852489707
  },
  {
    student: "Schirra, Heather",
    rand: 0.860434471
  },
  {
    student: "Guthrie, Zachary",
    rand: 0.860908335
  },
  {
    student: "Stites, Karli",
    rand: 0.946904298
  },
  {
    student: "Mubarak, Carl",
    rand: 0.962251524
  },
  {
    student: "Fahey, Joseph",
    rand: 0.998581
  }
];

export default presOrder;


// WEBPACK FOOTER //
// ./src/data/pres-order.js